<template>
    <div>
        <app-select
            label="Höhe der Galerie"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.type'"
            :data-default="{ type: 'raw', value: 'fix' }"
            :options="{ fix: 'Fixe Höhe', auto: 'Dynamische Höhe' }"
            hide-clear
            required
        ></app-select>
        <app-list
            :data-source="'tecpage.user.modules.' + moduleId + '.data.slides'"
            :data-preset="false"
            :data-name="'data.title'"
            :list-label="'Folie'"
            :list-subpage="'Gallery'"
            :allow-individual="true"
            :label="'Folie'"
        ></app-list>
    </div>
</template>

<script>
import List from '@/components/fields/complex/List.vue';
import Select from '@/components/fields/simple/Select.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {},
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R005'),
            help: this.$helpers.uiText('R028'),
            removeText: this.$helpers.uiText('R026'),
            showGlobal: false
        });
    },
    props: {
        moduleId: String
    },
    components: {
        'app-list': List,
        'app-select': Select
    }
};
</script>
